<template>
    <div class="bill-container">
        <h1 class="page-title">月票繳費單</h1>
        <h1 class="deport-name">{{ depName }}</h1>
        <div class="bill-content">
            <div class="left-column">
                <div class="field">
                    <label>繳費銀行</label>
                    <span>{{ bankName }}（{{ bankId }}）</span>
                </div>
                <div class="field">
                    <label>繳費金額</label>
                    <span>${{ amount }}</span>
                </div>
                <div class="field">
                    <label>繳費帳號</label>
                    <span>{{ accountNo }}</span>
                </div>
                <div class="field">
                    <label>繳費期限</label>
                    <span class="due-date">{{ dueDate }}</span>
                </div>
            </div>
            <div class="right-column">
                <div class='barcode-warning'>
                    <label class="barcode-label">超商條碼（逾期無效）</label>
                    <label v-if="true" class="online-message" @click="goCardPayment">或使用線上刷卡</label>
                </div>
                <div v-if="false">
                    {{ QR_ID }}
                </div>

                <div class="barcodes">
                    <div v-for="(barcode, index) in barcodes" :key="index" class="barcode">
                        <svg :id="`barcode-${index}`" class="barcode-svg"></svg>
                        <span class="barcode-no">{{ barcode }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <a @click="goBillList()">回繳費服務頁面</a>

            <!-- <router-link to="/test-page">回繳費服務頁面</router-link> -->
        </div>
    </div>
</template>

<script>
import JsBarcode from "jsbarcode";

export default {
    props: {
        depName: {
            type: String,
            default: "",
        },
        bankName: {
            type: String,
            default: "Default Bank Name",
        },
        bankId: {
            type: String,
            default: "000",
        },
        amount: {
            type: Number,
            default: 0,
        },
        accountNo: {
            type: String,
            default: "000000000000000",
        },
        dueDate: {
            type: String,
            default: "2024-01-01",
        },
        barcodes: {
            type: Array,
            default: () => ["130905627", "130905627", "130905627"],
        },
        QR_ID: {
            type: String,
            default: "000000000000000",
        },
    },
    mounted() {
        this.generateBarcodes();
        // Hijack the back button by pushing a dummy state and adding popstate listener
        history.pushState(null, null, location.href);
        window.addEventListener("popstate", this.handleBackButton);
    },
    beforeUnmount() {
        // Remove the event listener when component is destroyed
        window.removeEventListener("popstate", this.handleBackButton);
        console.log("BillCoder and back button hijacker destroyed");
    },
    methods: {

        goCardPayment() {
            // this.$emit("go-card-payment");
            window.open(
                `https://webrent.taiwan-parking.com.tw/ParkingPay_cred/rpay.aspx?SIDPA=${this.QR_ID}`,
                "_blank"
            );
        },


        generateBarcodes() {
            this.barcodes.forEach((barcode, index) => {

                let hh = 70;
                if (index > 0) {
                    hh = 120;
                }

                const elementId = `barcode-${index}`;
                JsBarcode(`#${elementId}`, barcode, {
                    format: "CODE39",
                    lineColor: "#000",
                    width: 2,
                    height: hh,
                    displayValue: false,
                });

                //     const svgEl = this.$el.querySelector(`#barcode-${index}`);


                //    const fullH = svgEl.parentElement.clientHeight;
                //     svgEl.querySelectorAll('rect').forEach(r => {
                //         r.setAttribute('height', fullH);
                //     });
                //     // and make the svg container stretch
                //     svgEl.style.height = fullH + 'px';
                //     svgEl.style.width = '100%';                
                // // now override every <rect> height
                // const fullH = svgEl.parentElement.clientHeight;
                // svgEl.querySelectorAll('rect').forEach(r => {
                //     r.setAttribute('height', fullH);
                // });
                // // and make the svg container stretch
                // svgEl.style.height = fullH + 'px';
                // svgEl.style.width = '100%';
            });
        },

        generateBarcodesx() {
            this.barcodes.forEach((barcode, index) => {
                const svgEl = this.$el.querySelector(`#barcode-${index}`);
                JsBarcode(svgEl, barcode, {
                    format: "CODE39",
                    lineColor: "#000",
                    width: 2,
                    height: 60,            // initial draw
                    displayValue: false,
                });
                // // now override every <rect> height
                // const fullH = svgEl.parentElement.clientHeight;
                // svgEl.querySelectorAll('rect').forEach(r => {
                //     r.setAttribute('height', fullH);
                // });
                // // and make the svg container stretch
                // svgEl.style.height = fullH + 'px';
                // svgEl.style.width = '100%';
            });
        },
        goBillList() {
            this.$emit("go-bill-list");
        },
        handleBackButton() {
            // Disable the hijack and call goBillList on back press
            console.log("Back button pressed");
            window.removeEventListener("popstate", this.handleBackButton);
            this.goBillList();
        }
    },
};
</script>

<style scoped>
.bill-container {
    /* font-family: Arial, sans-serif; */
    /* margin: 20px; */
    /* padding: 20px; */
    background-color: var(--background-gray);
    /* border-radius: 10px; */
    /* border: 1px solid #ddd; */
    /* max-width: 600px; */
    padding-bottom: 215px;
}

.page-title {
    margin-bottom: 40px;
}

.deport-name {
    margin-bottom: 20px;
    font-size: 42px;
    font-weight: bold;
    color: var(--gray15);
    color: black;

}

.bill-content {
    display: flex;
    justify-content: space-between;


    width: 936px;
    height: 632px;
    border-radius: 20px;

    background-color: #FFFFFF;

    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    margin: 0 auto;

    box-sizing: border-box;

}

.left-column {
    width: 50%;

    padding: 48px;

    display: flex;
    flex-direction: column;

    gap: 48px;
}

.right-column {
    width: 50%;

    padding: 48px;

    text-align: left;
}

.field {
    margin-bottom: 15px;

    display: flex;
    flex-direction: column;
    gap: 5px;

    /* justify-content: flex-start; */
    align-items: flex-start;
}

label {

    /* //styleName: md/bold; */
    font-family: Inter;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

    color: var(--gray12);
}

span {
    display: block;
    margin-top: 4px;


    /* //styleName: xl/bold; */
    font-family: Inter;
    font-size: 20px;
    font-weight: 700;
    line-height: 30px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

    color: var(--gray15);

}

.due-date {
    color: var(--red02);
}

.barcode-warning {
    margin-bottom: 16px;

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    /* align-content: flex-end; */
}


.barcode-label {

    /* font-size: 14px;
    margin-bottom: 10px;
    font-weight: bold; */

    position: relative;
    top: 4px;
}

.online-message {
    /* margin-top: 10px; */
    font-size: 20px;



    /* underline */
    text-decoration: underline;


    color: var(--green03);
}


.barcodes {

    /* margin-top: 16px; */
    /* margin: auto auto; */

    /* padding: 70px 74px; */
    padding: 50px 50px;

    /* width: 408px; */
    width: 458px;
    height: 496px;

    border: 1px solid #ddd;
    border-radius: 12px;

    display: flex;
    flex-direction: column;
    gap: 40px;

    box-sizing: border-box;
}

.barcode {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    /* ensure children stretch full width */
    flex: 1;
    /* each .barcode shares the container’s height equally */
}

.barcode-svg {
    flex: 1;
    /* grow to fill all available vertical space */
    width: 100%;
    /* full width of its parent */
    height: 100%;
    /* full height of its parent flex-area */
}

.barcode-svg rect {
    fill: hotpink;
}


.barcode-no {
    /* font-size: 14px; */
    /* font-weight: bold; */
    color: var(--gray15);

    font-size: 12px;
    margin: 0 auto;
    margin-top: -10px;

}


.footer {
    text-align: center;
    margin-top: 40px;
    /* margin-bottom: 215px; */

    font-family: Inter;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    text-align: center;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;


}

.footer a {
    color: var(--green03);
}


@media screen and (max-width: 560px) {

    .bill-container {
        padding-bottom: 32px;
    }

    .page-title {
        margin-bottom: 10px;
    }

    .deport-name {
        margin-top: 0px;
        margin-bottom: 10px;
        font-size: 32px;
        font-weight: bold;
        /* color: var(--gray15); */

    }

    .bill-content {
        width: 343px;
        height: 765px;
        padding: 0px;

        flex-direction: column;
    }

    .left-column {
        width: 100%;

        padding: 20px;
        gap: 20px;
    }

    .field {
        gap: 4px;
        margin: 0px;
    }

    label {
        /* //styleName: xs/bold; */
        font-family: Inter;
        font-size: 12px;
        font-weight: 700;
        line-height: 18.48px;
        text-align: left;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
    }

    span {
        /* //styleName: md/bold; */
        font-family: Inter;
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
        text-align: left;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;

        margin: 0px;
    }


    .right-column {
        width: 303px;
        height: 449px;

        padding: 20px;
        padding-top: 0px;
    }


    .barcode-label {

        /* font-size: 14px;
margin-bottom: 10px;
font-weight: bold; */

        position: relative;
        top: 3.7px;
    }

    .barcode-warning {
        margin-bottom: 8px;
    }

    .barcodes {
        width: 303px;
        height: 420px;
        padding: 24px;

        gap: 40px;
    }

    .barcode-no {
        /* font-size: 14px; */
        /* font-weight: bold; */
        margin: 0 auto;
        margin-top: -5px;

    }

    .footer {
        margin-top: 20px;
        /* margin-bottom: 20px; */
    }

}
</style>